import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useStatsig } from '../hooks/useStatsig';
import { showSplash } from '../../actions/splash-actions';

const StatsigRedirect = ({ gate, enabledTo, disabledTo, ...rest }) => {
  const { checkGate } = useStatsig();
  const dispatch = useDispatch();
  const isEnabled = checkGate(gate);

  useEffect(() => {
    if (isEnabled && enabledTo) {
      // Always external
      dispatch(showSplash);
      window.location.href = enabledTo;
    }
  }, [isEnabled, enabledTo]);

  if (isEnabled) {
    return null;
  }

  // Internal routing via React Router
  return <Redirect to={disabledTo ?? enabledTo} {...rest} />;
};

export default StatsigRedirect;
